import React, { createContext } from "react";
import {
  IGlobalContext,
  IGlobalContextData,
} from "../type/contextType/globalContextType";

// Contextオブジェクトを作成する
export const GlobalContext = createContext<{
  state: IGlobalContextData;
  setState: (state: IGlobalContextData) => void;
}>({
  state: { authInfo: { contractorNo: "" } },
  setState: (state: IGlobalContextData) => {},
});

// Providerコンポーネントを作成し、子コンポーネントにContextデータを提供する
export const GlobalContextProvider: React.FC<IGlobalContext> = (props) => {
  const [state, setState] = React.useState<IGlobalContextData>({
    authInfo: {},
  });

  return (
    <GlobalContext.Provider
      data-testid="global-context-value"
      value={{ state, setState }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
};

export default GlobalContextProvider;
